// views/layouts/application.html.erb
//
// To see this message, add the following to the `<head>` section in your
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'


import { createApp } from "vue"
import App from "../components/App.vue"
import vueAwesomeSidebar from 'vue-awesome-sidebar'
import 'vue-awesome-sidebar/dist/vue-awesome-sidebar.css'

document.addEventListener('turbo:load', () => {
  var date = new Date();
  console.log(`Vite ⚡️ ${date.toUTCString()}`)

  const appProps = document.getElementById('appProps').dataset.props
  console.log(JSON.parse(appProps))
  const app = createApp(App, JSON.parse(appProps))
  app.use(vueAwesomeSidebar)
  app.mount("#app")

})
